import { memo } from 'react'
import { GroupItem } from '~containers/app/ask-a-vet/types'
import { cn } from '~utils/cn'

interface ExtraTextInputProps {
  root: GroupItem
  datafield: string
  placeholder: string
  onChange: (triggeredItem: GroupItem & { datafield: string }) => void
}

const ExtraTextInput = memo(({ root, datafield, placeholder, onChange }: ExtraTextInputProps) => {
  return (
    <input
      className={cn(
        'w-full rounded-xl bg-background p-4 text-gray-900 outline-none text-body-1 placeholder:text-gray-400 dark:placeholder:text-gray-600 dark:bg-gray-800 dark:border-gray-500 dark:border dark:text-white'
      )}
      type="text"
      value={root[datafield as keyof GroupItem] || ''}
      placeholder={placeholder}
      onChange={event => {
        onChange({
          value: event.target.value,
          datafield: datafield,
        })
      }}
      onKeyUp={event => {
        event.preventDefault()
      }}
      onClick={event => {
        event.stopPropagation()
      }}
    />
  )
})

ExtraTextInput.displayName = 'ExtraTextInput'

export default ExtraTextInput
